module.exports = __webpack_public_path__ + "static/media/avatar-10.1ccc3010.svg";